import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { TextField, useTheme } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { SlideTransition } from '../../../../../components/Transition/Transition';

export default function JoinRoomModal(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const { intl, open, onClose, handleChange, joinRoom } = props;

  return (
    <div>
      <Dialog
        open={open}
        onClose={onClose}
        keepMounted
        aria-labelledby="responsive-dialog-title"
        fullScreen={fullScreen}
        slots={{
          transition: SlideTransition
        }}
      >
        <DialogTitle id="responsive-dialog-title">{intl.formatMessage({ id: 'Join Meeting' })}</DialogTitle>
        <DialogContent className="dialog-content-centered">
          <div className="caseclose-form">
            <div className="form-group">
              <div className="col-md-6 col-xs-6 text-right">
                <label className="control-label">{intl.formatMessage({ id: 'Meeting ID' })} :</label>
              </div>
              <div className="col-md-6 col-xs-6 text-left">
                <TextField id="roomID" name="roomID" onChange={handleChange} />
              </div>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            {intl.formatMessage({ id: 'Close' })}
          </Button>
          <Button onClick={joinRoom} color="primary">
            {intl.formatMessage({ id: 'Join Meeting' })}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
